import { render, staticRenderFns } from "./DangerZone.vue?vue&type=template&id=4c87cfaa&scoped=true&lang=pug"
import script from "./DangerZone.vue?vue&type=script&lang=ts"
export * from "./DangerZone.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c87cfaa",
  null
  
)

export default component.exports